/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VendorErrorCategory } from './VendorErrorCategory';
import {
    VendorErrorCategoryFromJSON,
    VendorErrorCategoryFromJSONTyped,
    VendorErrorCategoryToJSON,
    VendorErrorCategoryToJSONTyped,
} from './VendorErrorCategory';
import type { VendorErrorParameter } from './VendorErrorParameter';
import {
    VendorErrorParameterFromJSON,
    VendorErrorParameterFromJSONTyped,
    VendorErrorParameterToJSON,
    VendorErrorParameterToJSONTyped,
} from './VendorErrorParameter';
import type { VendorErrorState } from './VendorErrorState';
import {
    VendorErrorStateFromJSON,
    VendorErrorStateFromJSONTyped,
    VendorErrorStateToJSON,
    VendorErrorStateToJSONTyped,
} from './VendorErrorState';
import type { VendorErrorImpactedComponent } from './VendorErrorImpactedComponent';
import {
    VendorErrorImpactedComponentFromJSON,
    VendorErrorImpactedComponentFromJSONTyped,
    VendorErrorImpactedComponentToJSON,
    VendorErrorImpactedComponentToJSONTyped,
} from './VendorErrorImpactedComponent';
import type { VendorErrorSeverity } from './VendorErrorSeverity';
import {
    VendorErrorSeverityFromJSON,
    VendorErrorSeverityFromJSONTyped,
    VendorErrorSeverityToJSON,
    VendorErrorSeverityToJSONTyped,
} from './VendorErrorSeverity';

/**
 * 
 * @export
 * @interface CreateVendorErrorCodeRequestDto
 */
export interface CreateVendorErrorCodeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateVendorErrorCodeRequestDto
     */
    manufacturerId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVendorErrorCodeRequestDto
     */
    assetTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVendorErrorCodeRequestDto
     */
    errorCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVendorErrorCodeRequestDto
     */
    matchType?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVendorErrorCodeRequestDto
     */
    matchKey?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVendorErrorCodeRequestDto
     */
    vendorErrorCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVendorErrorCodeRequestDto
     */
    info?: string;
    /**
     * 
     * @type {VendorErrorParameter}
     * @memberof CreateVendorErrorCodeRequestDto
     */
    parameter?: VendorErrorParameter;
    /**
     * 
     * @type {VendorErrorState}
     * @memberof CreateVendorErrorCodeRequestDto
     */
    state?: VendorErrorState;
    /**
     * 
     * @type {VendorErrorImpactedComponent}
     * @memberof CreateVendorErrorCodeRequestDto
     */
    impactedComponent?: VendorErrorImpactedComponent;
    /**
     * 
     * @type {VendorErrorCategory}
     * @memberof CreateVendorErrorCodeRequestDto
     */
    category?: VendorErrorCategory;
    /**
     * 
     * @type {VendorErrorSeverity}
     * @memberof CreateVendorErrorCodeRequestDto
     */
    severity?: VendorErrorSeverity;
    /**
     * 
     * @type {string}
     * @memberof CreateVendorErrorCodeRequestDto
     */
    firmwareVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVendorErrorCodeRequestDto
     */
    description?: string;
}



/**
 * Check if a given object implements the CreateVendorErrorCodeRequestDto interface.
 */
export function instanceOfCreateVendorErrorCodeRequestDto(value: object): value is CreateVendorErrorCodeRequestDto {
    if (!('manufacturerId' in value) || value['manufacturerId'] === undefined) return false;
    if (!('assetTypeId' in value) || value['assetTypeId'] === undefined) return false;
    if (!('errorCode' in value) || value['errorCode'] === undefined) return false;
    return true;
}

export function CreateVendorErrorCodeRequestDtoFromJSON(json: any): CreateVendorErrorCodeRequestDto {
    return CreateVendorErrorCodeRequestDtoFromJSONTyped(json, false);
}

export function CreateVendorErrorCodeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateVendorErrorCodeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'manufacturerId': json['manufacturerId'],
        'assetTypeId': json['assetTypeId'],
        'errorCode': json['errorCode'],
        'matchType': json['matchType'] == null ? undefined : json['matchType'],
        'matchKey': json['matchKey'] == null ? undefined : json['matchKey'],
        'vendorErrorCode': json['vendorErrorCode'] == null ? undefined : json['vendorErrorCode'],
        'info': json['info'] == null ? undefined : json['info'],
        'parameter': json['parameter'] == null ? undefined : VendorErrorParameterFromJSON(json['parameter']),
        'state': json['state'] == null ? undefined : VendorErrorStateFromJSON(json['state']),
        'impactedComponent': json['impactedComponent'] == null ? undefined : VendorErrorImpactedComponentFromJSON(json['impactedComponent']),
        'category': json['category'] == null ? undefined : VendorErrorCategoryFromJSON(json['category']),
        'severity': json['severity'] == null ? undefined : VendorErrorSeverityFromJSON(json['severity']),
        'firmwareVersion': json['firmwareVersion'] == null ? undefined : json['firmwareVersion'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateVendorErrorCodeRequestDtoToJSON(json: any): CreateVendorErrorCodeRequestDto {
    return CreateVendorErrorCodeRequestDtoToJSONTyped(json, false);
}

export function CreateVendorErrorCodeRequestDtoToJSONTyped(value?: CreateVendorErrorCodeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'manufacturerId': value['manufacturerId'],
        'assetTypeId': value['assetTypeId'],
        'errorCode': value['errorCode'],
        'matchType': value['matchType'],
        'matchKey': value['matchKey'],
        'vendorErrorCode': value['vendorErrorCode'],
        'info': value['info'],
        'parameter': VendorErrorParameterToJSON(value['parameter']),
        'state': VendorErrorStateToJSON(value['state']),
        'impactedComponent': VendorErrorImpactedComponentToJSON(value['impactedComponent']),
        'category': VendorErrorCategoryToJSON(value['category']),
        'severity': VendorErrorSeverityToJSON(value['severity']),
        'firmwareVersion': value['firmwareVersion'],
        'description': value['description'],
    };
}

